import { OpcionSelect } from "src/components/input/TextInput";
import {
  EstadoCampo,
  EstadoCampoProps,
  IitemAspiranteResponse,
  VerificacionResponse,
} from "src/redux/api/types/aspirantes";
import * as Yup from "yup";
import { ConceptoVerificacion } from "src/utils/aspirantes/verificaciones";
import { EuiHealth } from "@elastic/eui";

// Filtros form
export interface IAsignarGestorForm {
  usuarioAsignadoId: string;
}

export const setValoresInicialesNuevoMaestro = (
  valores?: IitemAspiranteResponse,
) => {
  return { usuarioAsignadoId: valores?.usuarioAsignadoId ?? "" };
};

export const esquemaDeValidacion = Yup.object({
  // usuarioAsignadoId:  Yup.string().required("Debe seleccionar un usuario"),
});

export const opcionesVerificacionCampo: OpcionSelect[] = [
  {
    valor: "APROBADO",
    label: (
      <EuiHealth color={EstadoCampoProps[EstadoCampo.APROBAR].color}>
        {EstadoCampoProps[EstadoCampo.APROBAR].label}
      </EuiHealth>
    ),
    color: "success",
  },
  {
    valor: "DEVUELTO",
    label: (
      <EuiHealth color={EstadoCampoProps[EstadoCampo.DEVUELTO].color}>
        {EstadoCampoProps[EstadoCampo.DEVUELTO].label}
      </EuiHealth>
    ),
    color: "success",
  },
  {
    valor: "RECHAZADO",
    label: (
        <EuiHealth color={EstadoCampoProps[EstadoCampo.RECHAZAR].color}>
          {EstadoCampoProps[EstadoCampo.RECHAZAR].label}
        </EuiHealth>
      ),
    color: "error",
  },
  {
    valor: "PENDIENTE",
    label: (
        <EuiHealth color={EstadoCampoProps[EstadoCampo.PENDIENTE].color}>
          {EstadoCampoProps[EstadoCampo.PENDIENTE].label}
        </EuiHealth>
      ),
    color: "error",
  },
];

export const opcionesEstadoSolicitud: OpcionSelect[] = [
  {
    valor: "RECIBIDO",
    label: (
      <EuiHealth color={EstadoCampoProps[EstadoCampo.APROBAR].color}>
        {EstadoCampoProps[EstadoCampo.APROBAR].label}
      </EuiHealth>
    ),
    color: "success",
  },
];

// Verificaciones form
export interface IitemVerificacion {
  verificacionId: string;
  estado: string;
  comentarios: string;
}

export interface IverificacionesForm {
  tipoIdentificacion: IitemVerificacion;
  identificacion: IitemVerificacion;
  primerNombre: IitemVerificacion;
  segundoNombre: IitemVerificacion;
  primerApellido: IitemVerificacion;
  segundoApellido: IitemVerificacion;
  fechaNacimiento: IitemVerificacion;
  sexo: IitemVerificacion;
  correoElectronico: IitemVerificacion;
  numeroCelular: IitemVerificacion;
  departamentoResidenciaId: IitemVerificacion;
  municipioResidenciaId: IitemVerificacion;
  perfilId: IitemVerificacion;
  documentoIdentidadAdjuntoId: IitemVerificacion;
  tarjetaProfesionalAdjuntoId: IitemVerificacion;
  certificadoContraloriaAdjuntoId: IitemVerificacion;
  certificadoProcuraduriaAdjuntoId: IitemVerificacion;
  certificadoPoliciaNacionalAdjuntoId: IitemVerificacion;
  certificadoRnmcAdjuntoId: IitemVerificacion;
  formacionesAcademicas: IitemVerificacion;
  fechaExpedicionTarjetaProfesional: IitemVerificacion;
  experienciasLaborales: IitemVerificacion;
  horariosDisponibles: IitemVerificacion;
  sedesDisponibles: IitemVerificacion;
  hojaDeVidaAdjuntoId: IitemVerificacion
  certificadoAntecedentesDisciplinariosId: IitemVerificacion;
}

export interface IestadoForm {
  estado: string
  numeroRadicado: string,
  fechaRadicado: string
  observacionRechazo?: string
}

export const buscarElemento = (
  valores: VerificacionResponse[],
  concepto: ConceptoVerificacion,
): IitemVerificacion => {
  const elemento = valores.filter((valor) => {
    return valor.concepto === concepto;
  });
  if (elemento) {
    return {
      verificacionId: elemento[0].verificacionId,
      estado: elemento[0].estado,
      comentarios: elemento[0].comentarios,
    };
  }
  return {
    verificacionId: "",
    estado: "",
    comentarios: "",
  };
};

export const setValoresInicialesFormEstado = (estado: string, numeroRadicado: string, fechaRadicado: string, observacionRechazo?: string): IestadoForm => {

  return {
  estado,
  numeroRadicado,
  fechaRadicado,
  observacionRechazo: observacionRechazo ?? "",
 }
}

export const setValoresInicialesVerificaciones = (
  valores: VerificacionResponse[],
): IverificacionesForm => {
  return {
    tipoIdentificacion: buscarElemento(
      valores,
      ConceptoVerificacion.TIPO_IDENTIFICACION,
    ),
    identificacion: buscarElemento(
      valores,
      ConceptoVerificacion.IDENTIFICACION,
    ),
    primerNombre: buscarElemento(valores, ConceptoVerificacion.PRIMER_NOMBRE),
    segundoNombre: buscarElemento(valores, ConceptoVerificacion.SEGUNDO_NOMBRE),
    primerApellido: buscarElemento(
      valores,
      ConceptoVerificacion.PRIMER_APELLIDO,
    ),
    segundoApellido: buscarElemento(
      valores,
      ConceptoVerificacion.SEGUNDO_APELLIDO,
    ),
    fechaNacimiento: buscarElemento(
      valores,
      ConceptoVerificacion.FECHA_NACIMIENTO,
    ),
    sexo: buscarElemento(valores, ConceptoVerificacion.SEXO),
    correoElectronico: buscarElemento(
      valores,
      ConceptoVerificacion.CORREO_ELECTRONICO,
    ),
    numeroCelular: buscarElemento(valores, ConceptoVerificacion.NUMERO_CELULAR),
    departamentoResidenciaId: buscarElemento(
      valores,
      ConceptoVerificacion.DEPARTAMENTO_RESIDENCIA,
    ),
    municipioResidenciaId: buscarElemento(
      valores,
      ConceptoVerificacion.MUNICIPIO_RESIDENCIA,
    ),
    perfilId: buscarElemento(
      valores,
      ConceptoVerificacion.PERFIL_ID,
    ),
    documentoIdentidadAdjuntoId: buscarElemento(
      valores,
      ConceptoVerificacion.DOCUMENTO_IDENTIDAD_ADJUNTO,
    ),
    tarjetaProfesionalAdjuntoId: buscarElemento(
      valores,
      ConceptoVerificacion.TARJETA_PROFESIONAL_ADJUNTO,
    ),
    certificadoAntecedentesDisciplinariosId: buscarElemento(
      valores,
      ConceptoVerificacion.CERTIFICADO_ANTECEDENTES_DISCIPLINARIOS_ADJUNTO,
    ),
    certificadoContraloriaAdjuntoId: buscarElemento(
      valores,
      ConceptoVerificacion.CERTIFICADO_CONTRALORIA_ADJUNTO,
    ),
    certificadoProcuraduriaAdjuntoId: buscarElemento(
      valores,
      ConceptoVerificacion.CERTIFICADO_PROCURADURIA_ADJUNTO,
    ),
    certificadoPoliciaNacionalAdjuntoId: buscarElemento(
      valores,
      ConceptoVerificacion.CERTIFICADO_POLICIA_NACIONAL_ADJUNTO,
    ),
    certificadoRnmcAdjuntoId: buscarElemento(
      valores,
      ConceptoVerificacion.CERTIFICADO_RNMC_ADJUNTO,
    ),
    formacionesAcademicas: buscarElemento(
      valores,
      ConceptoVerificacion.FORMACIONES_ACADEMICA,
    ),
    fechaExpedicionTarjetaProfesional: buscarElemento(
      valores,
      ConceptoVerificacion.FECHA_EXPEDICION_TARJETA_PROFESIONAL,
    ),
    experienciasLaborales: buscarElemento(
      valores,
      ConceptoVerificacion.EXPERIENCIAS_LABORALES,
    ),
    horariosDisponibles: buscarElemento(
      valores,
      ConceptoVerificacion.HORARIOS_DISPONIBLES,
    ),
    sedesDisponibles: buscarElemento(
      valores,
      ConceptoVerificacion.SEDES_DISPONIBLES,
    ),
    hojaDeVidaAdjuntoId: buscarElemento(
      valores, ConceptoVerificacion.HOJA_DE_VIDA
    )
  };
};
